import { createContext, useEffect, useState } from 'react';

export const DirectionContext = createContext();

export const DirectionProvider = ({ children }) => {
  const [dir, setDir] = useState(document.body.dir || 'rtl');

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setDir(document.body.dir);
    });

    observer.observe(document.body, { attributes: true, attributeFilter: ['dir'] });

    return () => observer.disconnect();
  }, []);

  return (
    <DirectionContext.Provider value={{ dir, setDir }}>
      {children}
    </DirectionContext.Provider>
  );
};
